// CSS Modules - uses _mondaywebforms.scss because it's an external module

<template>
  <div class="mwf-form">
    <div v-bind:id="containerId"></div>
    <ReCaptcha
      v-if="config.useRecaptcha"
      :executeSwitch="executeSwitch"
      :submit="getToken"
    />
  </div>
</template>

<script>
import { isIE, isEdge } from "mobile-device-detect";
import * as Storage from "../../shared/Storage";
import ReCaptcha from "../ReCaptcha/ReCaptcha";
import {
  MwfFormNamesAndIds,
  MwfFormPrefixes
} from "../../globals/constants/mwf";

export default {
  name: "MondayWebforms",
  components: {
    ReCaptcha
  },
  props: {
    config: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      htmlElement: null,
      containerId: null,
      executeSwitch: false,
      mwfLabelCollection: [],
      mwfKeys: []
    };
  },
  methods: {
    getToken(token) {
      const tokenField = document.getElementById(MwfFormNamesAndIds.TOKEN);
      if (tokenField) {
        tokenField.value = token;
      }
    },
    wrapFields() {
      this.mwfLabelCollection = [];
      this.mwfKeys = [];
      let fields = document.querySelectorAll(".mwf-form .mwf-field");

      for (let i in fields) {
        let field = fields[i];
        let children = field.children;

        if (!children) continue;

        let wrapper = document.createElement("div");
        wrapper.classList.add("mwf-wrapper");

        while (children.length > 0) {
          wrapper.appendChild(children[0]);
        }

        field.appendChild(wrapper);

        this.setMWFLabelsAndKeys(field);
      }
    },
    initHiddenFields(form) {
      if (currentCountry) {
        let input = document.createElement("input");
        input.type = "hidden";
        input.value = currentCountry;
        input.name = MwfFormNamesAndIds.COUNTRY;
        form.appendChild(input);
      }
      if (window.location.host && window.location.pathname) {
        let input = document.createElement("input");
        input.type = "hidden";
        input.value = window.location.host + window.location.pathname;
        input.name = MwfFormNamesAndIds.PAGE_URL;
        form.appendChild(input);
      }
      if (window.location.hostname) {
        let input = document.createElement("input");
        input.type = "hidden";
        input.value = window.location.hostname;
        input.name = MwfFormNamesAndIds.DOMAIN;
        form.appendChild(input);
      }
      if (currentLanguage) {
        let input = document.createElement("input");
        input.type = "hidden";
        input.value = currentLanguage;
        input.name = MwfFormNamesAndIds.LANGUAGE;
        form.appendChild(input);
      }
      if (this.config.useRecaptcha) {
        let input = document.createElement("input");
        input.type = "hidden";
        input.value = ""; // Is set by getToken method
        input.name = "token";
        input.id = MwfFormNamesAndIds.TOKEN;
        form.appendChild(input);
      }

      if (this.config.mailData) {
        for (const [key, value] of Object.entries(this.config.mailData)) {
          let input = document.createElement("input");
          input.type = "hidden";
          input.value = value;
          input.name = `${MwfFormPrefixes.MAIL_DATA}${key}`;
          input.id = `${MwfFormPrefixes.MAIL_DATA}${key}`;
          form.appendChild(input);
        }
      }

      if (this.mwfLabelCollection && this.mwfLabelCollection.length) {
        for (const labelObj of this.mwfLabelCollection) {
          let input = document.createElement("input");
          input.type = "hidden";
          input.value = labelObj.label;
          input.name = `${MwfFormPrefixes.FORM_LABEL}${labelObj.key}`;
          input.id = `${MwfFormPrefixes.FORM_LABEL}${labelObj.key}`;
          form.appendChild(input);
        }
      }

      if (this.mwfKeys && this.mwfKeys.length) {
        let input = document.createElement("input");
        input.type = "hidden";
        input.value = this.mwfKeys.join(",");
        input.name = MwfFormNamesAndIds.FORM_ELEMENT_SEQUENCE;
        input.id = MwfFormNamesAndIds.FORM_ELEMENT_SEQUENCE;
        form.appendChild(input);
      }

      //Form-ID
      let input = document.createElement("input");
      input.type = "hidden";
      input.value = form.dataset["mwfId"];
      input.name = MwfFormNamesAndIds.FORM_ID;
      form.appendChild(input);
    },
    initRequired() {
      // style required field labels
      let i;
      const span = this.htmlElement.getElementsByClassName("mwf-required");
      for (i = 0; i < span.length; i++) {
        span[i].parentElement.classList.add("mwf-label-required");
      }
      //window.addEventListener("scroll", this.handleScroll);
    },
    initErrors() {
      // highlight invalid input
      let i, j;
      const p = this.htmlElement.getElementsByClassName("mwf-error");
      for (i = 0; i < p.length; i++) {
        let inputs = p[i].parentElement.querySelectorAll("input,textarea");
        for (j = 0; j < inputs.length; j++) {
          inputs[j].classList.add("mwf-invalid-input");
        }
      }
    },
    initSelects() {
      // style custom selects
      let select,
        i,
        parentElm,
        selElm,
        customInput,
        optionsContainer,
        ul,
        defaultVal;
      // find mwf selects
      select = this.htmlElement.getElementsByClassName("mwf-select");
      for (i = 0; i < select.length; i++) {
        
        // added currentCountry as preselected value if we had an country except Corporate Website (EN)
        if ((currentCountry != 'DE' || currentCountry == 'DE' && currentLanguage != 'EN') && select[i].hasAttribute('data-mwf-datasource'))
        {
          if (select[i].getAttribute('data-mwf-datasource').includes('"datasource":"countries"') && !select[i].getAttribute('data-mwf-datasource').includes('"preselected" : "' + currentCountry + '"'))
          {
            select[i].setAttribute('data-mwf-datasource', select[i].getAttribute('data-mwf-datasource').replace(/preselected" : ".*",/g,"preselected\" : \"" + currentCountry + "\","));
          }
        }      
        if (select[i].classList.contains("mwf-select-hide")) continue;
        selElm = select[i];
        selElm.classList.add("mwf-select-hide");
        parentElm = selElm.parentElement;
        parentElm.classList.add("FormSelect__container");
        parentElm.insertBefore(parentElm.previousElementSibling, selElm);
        /* For each element, create a new DIV that will act as the selected item: */
        customInput = document.createElement("div");
        customInput.setAttribute("class", "FormSelect__input");
        defaultVal = selElm.options[selElm.selectedIndex]
          ? selElm.options[selElm.selectedIndex].innerHTML
          : "";
        customInput.innerHTML =
          "<span>" +
          defaultVal +
          '</span><span class="FormSelect__triangle"></span>';
        parentElm.appendChild(customInput);
        // cerate option list within div
        optionsContainer = document.createElement("div");
        optionsContainer.setAttribute(
          "class",
          "FormSelect__optionsContainer mwf-select-hide"
        );
        ul = document.createElement("ul");
        ul.setAttribute("class", "FormSelect__options");
        this.createOptions(selElm, ul);
        optionsContainer.appendChild(ul);
        parentElm.appendChild(optionsContainer);
        // toggle option list
        customInput.addEventListener("click", this.eventToggleCustomSelect);
      }

      // close all open selects but not current
      window.addEventListener("click", this.eventCloseCustomSelects);
    },
    updateSelects(elem) {
      let parent = elem.parentElement;
      let optionsContainer = parent.getElementsByClassName(
        "FormSelect__options"
      )[0];
      while (optionsContainer.firstChild) {
        optionsContainer.removeChild(optionsContainer.lastChild);
      }
      
	  // added currentCountry as preselected value if we had an country except Corporate Website (EN)
      for (var j = 0; j < elem.options.length; j++) {
        if (elem.options[j].getAttribute('data-mwf-value') == currentCountry && (currentCountry != 'DE' || currentCountry == 'DE' && currentLanguage != 'EN'))        
        {
          elem.options[j].setAttribute('selected', 'selected');        
        }
      }

      let defaultVal = elem.options[elem.selectedIndex]
        ? elem.options[elem.selectedIndex].innerHTML
        : "";

      parent.querySelectorAll(
        ".FormSelect__input span"
      )[0].innerHTML = defaultVal;

      this.createOptions(elem, optionsContainer);
    },
    createOptions(select, ul) {
      let options = select.options;
      for (let j = 0; j < options.length; j++) {
      
        // added currentCountry as preselected value if we had an country except Corporate Website (EN)
        if (select.options[j].getAttribute('data-mwf-value') == currentCountry && (currentCountry != 'DE' || currentCountry == 'DE' && currentLanguage != 'EN'))
        {
          select.options[j].setAttribute('selected', 'selected');
        }
        // create a new li for each option as option item
        let addClass =
          j === select.selectedIndex ? ' class="FormSelect__highlighted"' : "";
        let li = document.createElement("li");
        li.setAttribute("class", "FormSelect__option");
        li.innerHTML =
          "<span" + addClass + ">" + select.options[j].innerHTML + "</span>";
        li.addEventListener("click", function() {
          // update input select and mark li as selected
          let i, k, parentSelect, cstmInput, optionSpan, highlighted;
          parentSelect = this.parentNode.parentNode.parentNode.getElementsByTagName(
            "select"
          )[0];
          cstmInput = this.parentNode.parentNode.previousSibling;
          for (i = 0; i < parentSelect.length; i++) {
            optionSpan = this.getElementsByTagName("span")[0].innerHTML;
            if (parentSelect.options[i].innerHTML === optionSpan) {
              parentSelect.selectedIndex = i;
              cstmInput.getElementsByTagName("span")[0].innerHTML = optionSpan;
              highlighted = this.parentNode.getElementsByClassName(
                "FormSelect__highlighted"
              );
              for (k = 0; k < highlighted.length; k++) {
                highlighted[k].removeAttribute("class");
              }
              this.getElementsByTagName("span")[0].setAttribute(
                "class",
                "FormSelect__highlighted"
              );
              break;
            }
          }
          cstmInput.click();
        });
        ul.appendChild(li);
      }
    },
    eventToggleCustomSelect(e) {
      // close option list
      e.stopPropagation();
      this.eventCloseCustomSelects(e.currentTarget);
      e.currentTarget.nextSibling.classList.toggle("mwf-select-hide");
      e.currentTarget.parentElement.classList.toggle("FormSelect__active");
    },
    eventCloseCustomSelects(elmnt) {
      // closes all other selects
      let x,
        y,
        i,
        arrNo = [];
      x = this.htmlElement.getElementsByClassName(
        "FormSelect__optionsContainer"
      );
      y = this.htmlElement.getElementsByClassName("FormSelect__input");
      for (i = 0; i < y.length; i++) {
        if (elmnt === y[i]) {
          arrNo.push(i);
        } else {
          y[i].parentElement.classList.remove("FormSelect__active");
        }
      }
      for (i = 0; i < x.length; i++) {
        if (arrNo.indexOf(i)) {
          x[i].classList.add("mwf-select-hide");
        }
      }
    },
    initEventFocusInput() {
      let elms, parent, ps, i;
      elms = this.htmlElement.getElementsByClassName("mwf-text");
      for (i = 0; i < elms.length; i++) {
        parent = elms[i].parentElement;
        ps = parent.getElementsByClassName("mwf-hint")[0];
        if (ps && !ps.classList.contains("mwf-is-initialized")) {
          ps.addEventListener("click", function(e) {
            let element = e.currentTarget.parentElement.getElementsByClassName(
              "mwf-text"
            )[0];
            if (isIE && !isEdge) {
              element.classList.add("mwf-focused");
            }
            element.focus();
          });
          if (isIE && !isEdge) {
            ps.parentElement
              .getElementsByClassName("mwf-text")[0]
              .addEventListener("blur", function(e) {
                e.currentTarget.classList.remove("mwf-focused");
              });
          }
          ps.classList.add("mwf-is-initialized");
        }
      }
    },
    initEmptySearchForm(form) {
      let textarea = form.querySelector('textarea[name="message"]');
      if (textarea) {
        let failedSearchRequests = Storage.getLocalStorage(
          "failedSearchRequests",
          true
        );
        if (
          failedSearchRequests &&
          failedSearchRequests.terms &&
          failedSearchRequests.terms.length > 0
        ) {
          textarea.value += "\n\n" + failedSearchRequests.terms.join("\n");
          form
            .querySelector(".mwf-next input")
            .addEventListener("click", () => {
              Storage.removeLocalStorage("failedSearchRequests");
            });
        }
      }
    },
    setMWFLabelsAndKeys(field) {
      const fieldLabelElements = field.getElementsByTagName("label");

      for (const fieldLabelElement of fieldLabelElements) {
        const fieldLabel = fieldLabelElement.textContent;
        const fieldLabelForId = fieldLabelElement.getAttribute("for");
        const formElement = document.getElementById(fieldLabelForId);

        if (formElement) {
          const formElementKey = formElement.getAttribute("name");

          this.mwfLabelCollection.push({
            key: formElementKey,
            label: fieldLabel
          });
          this.mwfKeys.push(formElementKey);
        }
      }
    }
  },
  mounted() {
    this.containerId = this.config.selector.replace("#", "");
    document.addEventListener("mwf-ajax-finished", context => {
      let form = context.detail.$dest[0];
      this.htmlElement = document.querySelector("html");
      this.wrapFields();
      this.initHiddenFields(form);
      this.initRequired();
      this.initErrors();
      this.initEventFocusInput();
      this.initSelects();
      this.executeSwitch = true;
      if (form.classList.contains("empty-search-form")) {
        this.initEmptySearchForm(form);
      }
    });
    document.addEventListener("mwf-fill-dropdown", context => {
      this.updateSelects(context.detail.$elem[0]);
    });
  },
  updated() {
    if (jQuery && jQuery.mwfAjaxReplace) {
      jQuery.mwfAjaxReplace(this.config);
    }
  },
  destroyed() {
    window.removeEventListener("click", this.eventCloseCustomSelects);
  }
};
</script>
